import React from "react";
import PropTypes from "prop-types";
import Donut from "../donut/donut";
import CreateFloatingGroup from "../createFloatingGroup/createFloatingGroup";
import "./donutList.scss";

export function getDefaultChecked(donutValues) {
  const items = {};
  donutValues?.forEach((donutProps) => {
    items[donutProps.id] = true;
  });
  return items;
}

function DonutList(props) {
  const onMinusButtonClick = (donutProps) => () => {
    props.onMinusButtonClick(donutProps);
  };

  return (
    <div className="donut-group-wrapper">
      {props.donutValues.map((donutProps) => (
        <div key={donutProps.id} className="donut-wrapper" data-testid={`donut-${donutProps.id}`}>
          <Donut
            {...donutProps}
            url={donutProps.categoryTotalSalesRawDataLink}
            type={donutProps.type}
            growth={donutProps.growth}
            onMinusButtonClick={onMinusButtonClick(donutProps)}
          />
        </div>
      ))}
      {props.donutValues.length < props.maxDonuts && (
        <CreateFloatingGroup
          module={props.module}
          title={props.title + " (" + props.maxDonuts + " max)"}
          checkList={props.groupValues}
          onSubmit={props.onSubmit}
          modalHeight={props.modalHeight}
          modalWidth={props.modalWidth}
          modalMinWidth={props.modalMinWidth}
          modalMaxWidth={props.modalMaxWidth}
          selectHeight={props.selectHeight}
          defaultCheckedItems={
            props.treeView ? props.defaultCheckedItems : getDefaultChecked(props.donutValues)
          }
          selectedItems={props.selectedItems}
          treeView={props.treeView}
          itemWasChecked={props.itemWasChecked}
          modalTop={props.modalTop}
          maxDonuts={props.maxDonuts}
          maxChecked={props.maxChecked}
          modalPositionRight={props.modalPositionRight}
        />
      )}
      <div style={{ display: "table", clear: "both" }} />
    </div>
  );
}

DonutList.propTypes = {
  donutValues: PropTypes.arrayOf(PropTypes.shape(Donut.propTypes)),
  onMinusButtonClick: PropTypes.func,
  maxDonuts: PropTypes.number,
  groupValues: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.any,
      value: PropTypes.any
    })
  ),
  onSubmit: PropTypes.func.isRequired,
  selectHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modalWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modalHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  module: PropTypes.string,
  itemWasChecked: PropTypes.func,
  modalTop: PropTypes.number,
  maxChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  modalPositionRight: PropTypes.bool,
  title: PropTypes.string
};

DonutList.defaultProps = {
  maxDonuts: 3,
  modalHeight: 350,
  modalWidth: 250,
  maxChecked: false
};

export default DonutList;
